import React from 'react';
import styles from './JoinUnion.module.scss';

const WhyJoin = () => {
        return (
            <div className="container mt-4">
                <div className={styles.borderBox}>
                    <h5>Why join a union?</h5>
                    <p>
                        Unions support employees in the workplace by acting as an advocate for them collectively (and with the consent
                        of the employee, individually). Unions work with employers to make collective employment agreements – these are
                        agreements between employers and registered unions that cover employees in the employer’s workplace. They also
                        help employees with information and advice about work-related issues.
                    </p>
                </div>
            </div>
        );
    };

export default WhyJoin;